// src/components/exchange/exchangeConstants.js
// 언어교환 기능 전체(프로필 등록, 상대 탐색 등)에서 공통으로 쓰는 언어 목록이다.
// 여기에 하나만 추가하면 프로필 폼과 나중에 만들 탐색 화면에서 동시에 쓸 수 있다.
export const LANGUAGE_OPTIONS = [
  { code: 'ko', label: '한국어' },
  { code: 'en', label: '영어' },
  { code: 'ja', label: '일본어' },
  { code: 'zh', label: '중국어' },
  { code: 'es', label: '스페인어' },
  { code: 'fr', label: '프랑스어' },
  { code: 'de', label: '독일어' },
  { code: 'it', label: '이탈리아어' },
  { code: 'ru', label: '러시아어' },
  { code: 'pt', label: '포르투갈어' },
  { code: 'vi', label: '베트남어' },
  { code: 'th', label: '태국어' },
  { code: 'id', label: '인도네시아어' },
  { code: 'ar', label: '아랍어' },
];

// 언어 코드(code)로 화면에 보여줄 한글 이름(label)을 찾을 때 쓰는 함수이다.
// 예: getLanguageLabel('en') -> '영어'
export const getLanguageLabel = (code) => {
  const found = LANGUAGE_OPTIONS.find((lang) => lang.code === code);
  return found ? found.label : code;
};
